import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Button,
         Dialog,
         DialogContent,
         DialogTitle as MuiDialogTitle,
         Grid,
         Grow,
         IconButton,
         InputAdornment,
         Paper,
         Table,
         TableBody,
         TableCell,
         TableContainer,
         TableHead,
         TableRow,
         TextField,
         Tooltip,
         Typography,
         withWidth} from '@material-ui/core';
import { 
    Close as CloseIcon,
    ListAlt as ListAltIcon,
    PermIdentity as PermIdentityIcon,
    Person as PersonIcon, 
    PictureAsPdf as PictureAsPdfIcon,
    Refresh as RefreshIcon,
    Search as SearchIcon,
    VpnKey as VpnKeyIcon } from '@material-ui/icons';
//import Image from 'material-ui-image';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useAuth } from "./Auth";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LogoPng from './images/LOGOBORDEBLANCO.png';
import Swal from 'sweetalert2';
import swal from 'sweetalert';
import PdfElementReciept from './Elementos/PdfReciept';

const styles2 = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Grow direction="up" ref={ref} {...props} timeout={700}/>;
});

const DialogTitle = withStyles(styles2)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon style={{color:'red'}}/>
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
});

const useStyles = makeStyles(theme => ({
    root: {
        
    },
    root2: {
        height:'100vh',
        display:'flex',
    },
    header:{
        padding:0,
        margin:0, 
        height:150, 
        display:'flex', 
        flexDirection:'row', 
        justifyContent:'center',
    },
    subroot:{
        height:'70vh',
        alignSelf:'center'
    },
    subroot2:{
        height:'100vh',
        //background: 'linear-gradient(90deg, rgba(26,35,126,1) 0%, rgba(26,35,126,1) 35%, rgba(255,61,0,1) 100%)'
        background: 'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,61,0,1) 35%, rgba(26,35,126,1) 68%)',
        display:'flex',
        justifyContent:'center',
    },

}));

function Log({width}){
    const classes = useStyles();
    const [ formulario, setFormulario ] = useState({
        UserName:'',
        PassWord:''
    });
    const [ stateUser, setStateUser ] = useState(false);
    const [ statePassword, setStatePassword ] = useState(false);
    const { setAuthTokens, setShowAppbar, setOpen, setAdmin, isLoggedIn, setLoggedIn, setIsInLogin, setSavingAvatar, setAvatar, setUpdateAvatar, setImgA, setImagesAvatar, setRuta} = useAuth(); 
    const [ showElement, setShowElement ] = useState(true);
    const { enqueueSnackbar } = useSnackbar();
    const [ valFil, setValFil ] = useState('');
    const [ data, setData]= useState([]);
    const [ openRecibos, setOpenRecibos ] = useState(false);
    const [ getEmpresa, setEmpresa ] = useState({});
    
    
    useEffect(()=>{
        setIsInLogin(true);
        (async ()=>{
            const getEmpresas = await fetch('/api/Empresas');
            const jsnEmpresas = await getEmpresas.json();
            const arrEmpresas = jsnEmpresas.filter(el=> el.Empresa === 'INTERCOM')[0];
            setEmpresa(arrEmpresas);
        })()
        switch(width){
            case 'xs': setShowElement(false); break;
            case 'sm': setShowElement(false); break;
            case 'md': setShowElement(true); break;
            case 'lg': setShowElement(true); break;
            case 'xl': setShowElement(true); break;
            default: setShowElement(true); break;
        }
        if (isLoggedIn) return <Redirect to="/" />;
        
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        switch(width){
            case 'xs': setShowElement(false); break;
            case 'sm': setShowElement(false); break;
            case 'md': setShowElement(true); break;
            case 'lg': setShowElement(true); break;
            case 'xl': setShowElement(true); break;
            default: setShowElement(true); break;
        }
    },[width]);
    
    const handleLogin = () => { 
        if(formulario.UserName === ''){
            enqueueSnackbar('Casillero Usuario Vacio',{variant:'error'});
            setStateUser(true);
        }else 
        if(formulario.PassWord === ''){
            enqueueSnackbar('Casillero PassWord Vacio',{variant:'error'});
            setStatePassword(true);
        }else{
            fetch('/api/users/Login',{
            method:'POST',
            body: JSON.stringify(formulario),
            headers:{
               'Content-Type':'application/json'
           }
        })
        .then(response => response.json())
        .then(result=>{
            if (result.status){
                if(result.status === 'Usuario no Existe'){
                    enqueueSnackbar(result.status,{variant:'error'});
                    setStateUser(true);
                    setTimeout(()=>{
                        setStateUser(false);
                    },2000)
                }else 
                if(result.status === 'Clave Incorrecta'){
                    enqueueSnackbar(result.status,{variant:'error'});
                    setStatePassword(true);
                    setTimeout(()=>{
                        setStatePassword(true);
                    },2000)
                }else{
                    enqueueSnackbar(result.status,{variant:'error'});
                    setStateUser(true);
                    setStatePassword(true);
                    alert('COMUNIQUESE CON SISTEMAS');
                } 
            }else{
                enqueueSnackbar('Login Correcto',{variant:'success'});
                setRuta('/Home');
                setAuthTokens(result.message);
                if(result.message.Avatar){
                    if(result.message.Avatar !== ''){
                        setSavingAvatar(true);
                        setImgA(true);
                        setAvatar(result.message.Avatar);
                        setImagesAvatar([{data_url:result.message.Avatar}]);
                    }
                }
                switch(result.message.Type){
                    case 'ADMINISTRADOR': setAdmin(true); break;
                    default: console.log('LOGIN YOUNET')
                }
                setTimeout(()=>{
                    setOpen(true);
                    setShowAppbar(true);
                    setLoggedIn(true);
                    if(result.message.Avatar){
                        if(result.message.Avatar !== ''){
                            setUpdateAvatar(true)
                        }
                    }
                },1000);
            }
        });
        }
        

    };

    const handleFormulario = (e)=>{
        if(statePassword || stateUser){
            setStatePassword(false);
            setStateUser(false);
        }
        setFormulario({...formulario, [e.target.id]:e.target.value});
    };

    const handleFilterEl = ({target})=>{ setValFil(target.value);};
    
    const handleSearchCedula = async ()=>{
        if(valFil === '' || valFil.length < 4){
            enqueueSnackbar('C.I. INCORRECTO', {variant:'error'});
        }else{
            fetch('/api/recibosById',{
                method:'POST',
                body: JSON.stringify({CI:valFil }),
                headers:{ 'Content-Type': 'application/json' }
            }) 
            .then(response=> response.json())
            .then(result =>{
                setOpenRecibos(false);
                if(result.status){
                    Swal.fire({
                        title: result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                    });
                    
                }else{
                    if(result.length > 1){
                        swal({
                            title: "Ingrese su número celular con el código 593 al comienzo",
                            content: {
                              element: "input",
                              attributes: {
                                placeholder: "Celular",
                                type: "text",
                              },
                            },
                        }).then((value2)=>{
                            if(value2 === result[0].Number.toString()){
                                //const arr = result.shift();
                                setData(result);
                                if(!showElement)setOpenRecibos(true);
                            }else{
                                Swal.fire({
                                    title: 'VALIDACIÓN INVÁLIDA',
                                    icon:'error',
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonColor:'#005596',
                                    toast:true
                                })
                            }
                        })

                    }else{
                        Swal.fire({
                            title: 'CLIENTE SIN RECIBOS',
                            icon:'info',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596'
                        })
                    }
                }
            });
            
        }
    };

    const handleReset = ()=>{ 
        setValFil('');
        setData([]);
    };

    const handleOpenRecibos = ()=>{
        setOpenRecibos(true);
    };

    const handleCloseRecibos = ()=>{
        setOpenRecibos(false);
        setValFil('');
        setData([]);
    };

    return(
            <Grid container justifyContent='center' alignContent='center'spacing={5} style={{width:'100vw'}} >
                <Dialog 
                    fullWidth
                    onClose={handleCloseRecibos} 
                    open={openRecibos} 
                    TransitionComponent={Transition} 
                    keepMounted>
                    <DialogTitle id="customized-dialog-title" onClose={handleCloseRecibos}>
                        RECIBOS 
                    </DialogTitle>
                    <DialogContent>
                        <Grid container justifyContent='center' spacing={2}>
                            <Grid item xs={9}>                     
                                <TextField 
                                    id='CI'
                                    fullWidth
                                    label='id'
                                    value={valFil || ''}
                                    onChange={handleFilterEl}
                                    InputProps={{
                                        startAdornment: <PermIdentityIcon color='primary'/>,
                                        endAdornment: 
                                        <IconButton aria-label="search" onClick={handleSearchCedula} size='small'>
                                            <SearchIcon color='primary' />
                                        </IconButton>
                                    }}
                                    onKeyPress={(e)=>{
                                        const code = e.keyCode || e.which;
                                        if(code === 13)
                                        handleSearchCedula();
                                        }}
                                    variant='outlined'
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Tooltip title='RESET' placement='right' arrow>
                                    <span>
                                        <IconButton  color='primary' size='small' onClick={handleReset} >
                                            <RefreshIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip> 
                            </Grid>
                            <Grid item xs={12}>
                                <TableContainer component={Paper} style={{maxHeight:'90vh', overflowY:'auto'}}>
                                    <Table  aria-label="simple table">
                                        <TableHead>
                                        <TableRow>
                                            <TableCell align="left" >ACTION</TableCell>
                                            <TableCell align="left">NUMERO</TableCell>
                                            <TableCell align="left">PERIODO</TableCell>
                                            <TableCell align="left">STATUS</TableCell>
                                        </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {data.map((row) => (
                                            <TableRow key={row.name}sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align="left" >
                                                <TableCellAction info={row} getEmpresa={getEmpresa} />
                                            </TableCell>
                                            <TableCell align="left">{row.NumberReciept}</TableCell>
                                            <TableCell align="left">{row.PeriodoServicio}</TableCell>
                                            <TableCell align="left">{row.Status}</TableCell>
                                            </TableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
                <Grid item xl={4} lg={4} md={5} sm={8} xs={12} className={classes.root2}>
                        <Grid container justifyContent='center' className={classes.subroot} spacing={2}>
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={classes.header} >
                                <img src={LogoPng} alt='YouNET' width={330} height={150}/>
                            </Grid>
                            { !showElement &&
                                <Grid xs={12} style={{height:20}}>

                                </Grid>
                            }
                            <Grid item xl={8} lg={8} md={8} sm={10} xs={10} >
                                <TextField
                                    label='User'
                                    autoFocus={true}
                                    error={stateUser}
                                    variant='outlined'
                                    id='UserName'
                                    fullWidth      
                                    color='secondary'                          
                                    value={formulario.UserName || ''}
                                    onChange={handleFormulario}  
                                    onKeyPress={(event)=>{
                                        const code = event.keyCode || event.which;
                                        if(code === 13)  
                                            handleLogin()
                                    }}
                                    InputProps={{
                                        startAdornment:(
                                            <InputAdornment position='start'>
                                                <PersonIcon color='secondary'/>
                                            </InputAdornment>
                                        )
                                    }}               
                                />
                            </Grid>
                            <Grid item xl={8} lg={8} md={8} sm={10} xs={10} >
                                <TextField
                                    label='Password'
                                    error={statePassword}
                                    variant='outlined'
                                    id='PassWord'
                                    fullWidth
                                    color='secondary'
                                    value={formulario.PassWord || ''}
                                    onChange={handleFormulario}
                                    type='password'
                                    onKeyPress={(event)=>{
                                        const code = event.keyCode || event.which;
                                        if(code === 13)  
                                            handleLogin()
                                    }}
                                    InputProps={{
                                        startAdornment:<VpnKeyIcon color='secondary'/>
                                    }}
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} md={6} sm={6} xs={8} >
                                <Button fullWidth size='large' variant="contained" color='secondary' onClick={handleLogin}>
                                    Login
                                </Button>
                            </Grid>
                            { !showElement &&
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems: 'center', height:44}}>
                                    <Tooltip title='RECIBOS' placement='top' arrow>
                                        <span>
                                            <IconButton  color='primary'  onClick={handleOpenRecibos} size='medium' >
                                                <ListAltIcon />
                                            </IconButton>
                                        </span>
                                    </Tooltip> 
                                </Grid>
                            }
                        </Grid>
                </Grid>
                { showElement && 
                    <Grid item xl={8} lg={8} md={7} sm={12} xs={12} className={classes.subroot2}> 
                        <Paper style={{padding:10}}>
                            <Grid container justifyContent='center' spacing={2}>
                                <Grid item xs={6}>                     
                                    <TextField 
                                        id='CI'
                                        fullWidth
                                        label='id'
                                        value={valFil || ''}
                                        onChange={handleFilterEl}
                                        InputProps={{
                                            startAdornment: <PermIdentityIcon color='primary'/>,
                                            endAdornment: 
                                            <IconButton aria-label="search" onClick={handleSearchCedula} size='small'>
                                                <SearchIcon color='primary' />
                                            </IconButton>
                                        }}
                                        onKeyPress={(e)=>{
                                            const code = e.keyCode || e.which;
                                            if(code === 13)
                                            handleSearchCedula();
                                            }}
                                        variant='outlined'
                                        size='small'
                                    />
                                </Grid>
                                <Grid item>
                                    <Tooltip title='RESET' placement='right' arrow>
                                        <span>
                                            <IconButton  color='primary' size='small' onClick={handleReset}  >
                                                <RefreshIcon />
                                            </IconButton>
                                        </span>
                                    </Tooltip> 
                                </Grid>
                                <Grid item xs={12}>
                                    <TableContainer component={Paper} style={{maxHeight:600, overflowY:'auto'}}>
                                        <Table  aria-label="simple table">
                                            <TableHead>
                                            <TableRow>
                                                <TableCell align="left" >ACTION</TableCell>
                                                <TableCell align="left">NUMERO</TableCell>
                                                <TableCell align="left">PERIODO</TableCell>
                                                <TableCell align="left">STATUS</TableCell>
                                            </TableRow>
                                            </TableHead>
                                            <TableBody >
                                            {data.map((row) => (
                                                <TableRow key={row.name}sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align="left" >
                                                    <TableCellAction info={row} getEmpresa={getEmpresa}/>
                                                </TableCell>
                                                <TableCell align="left">{row.NumberReciept}</TableCell>
                                                <TableCell align="left">{row.PeriodoServicio}</TableCell>
                                                <TableCell align="left">{row.Status}</TableCell>
                                                </TableRow>
                                            ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid> 
                        </Paper>
                    </Grid>}          
            </Grid>
    );
};

const TableCellAction = ({info, getEmpresa})=>{

    const [ isReadyPdfReciept, setReadyPdfReciept ] = useState(false);

    const handleCreatePdfReciept = ()=>{ setReadyPdfReciept(true) };

    const handleClickPdfReciept = ()=>{
        setTimeout(()=>{
            setReadyPdfReciept(false);
        },1000);
    };

    return(
        <Grid container spacing={1} justifyContent='center'>
            <Grid item >
                <Tooltip title='PDF' placement='top' arrow>
                    <span>
                    <IconButton size="small" onClick={handleCreatePdfReciept} color='primary' style={{marginTop:-3}}>
                        <PictureAsPdfIcon />
                    </IconButton>
                    </span>
                </Tooltip>
            </Grid>
            <Grid item style={{alignSelf: 'center', marginTop:-5}}>
                {isReadyPdfReciept && <PdfElementReciept data={info} HandleClickPdf={handleClickPdfReciept} InfoEmpresa={getEmpresa} isSmall={true}/>}
            </Grid>
        </Grid>

    )
};


function Login({width}){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}>
          <Log width={width}/>
        </SnackbarProvider>
      );
};

export default withWidth()(Login);